<template>
  <router-btn :icon="'mdi-delete'" :color="isDeleteable ? 'error' : 'disabled'" :disabled="false" outlined
    :textbtn="textbtn" :large="large" :small="small" :loading="loading"
    :info="$t('servicesystem.common_objects.commonterms.delete')" @Press="isDeleteable ? action() : null">
  </router-btn>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "DeleteJobBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [clientAPI],

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async action() {
      var config = {
        title: this.$t("servicesystem.common_objects.job.delete_job_confirm_title"),
        message: this.$t("servicesystem.common_objects.job.delete_job_confirm_body"),
      };
      var result = await this.$store.dispatch("ConfirmDialog/Show", config);
      if (result) {
        this.loading = true;
        this.deleteParentJob(this.$route.params.jobId)
          .then(() => {
            this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        //User canceled removal so dont do anything
      }
    },
  },

  computed: {
    isDeleteable() {
      return this.$store.getters["JobHub/IsDeleteable"];
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
